const items = document.querySelectorAll(".js-topCounter");

const isFloat = (n) => {
  return Number(n) === n && n % 1 !== 0;
};

// 小数点以下の桁数の計算
const getDecimalPointLength = (n) => {
  // n を一旦文字列に変換し、 ' . ' の位置で区切った配列から小数点以下が含まれる2番目([1])の配列アイテムの長さを取得
  return (String(n).split(".")[1] || "").length;
};

const observeAction = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      if (!entry.target.classList.contains("is-visible")) {
        const counterEle = entry.target.querySelector(".js-topCounterDetail .js-topCounterNumber");
        const from = parseFloat(entry.target.dataset.from || 0);
        const to = parseFloat(entry.target.dataset.to || 0);
        const duration = parseInt(entry.target.dataset.duration) || 1500;

        if (!Number.isFinite(from) || !Number.isFinite(to) || from > to) {
          return false;
        }

        const increment = to - from;
        // カウント量の小数点以下の桁数の取得
        const deciamlPointLength = getDecimalPointLength(increment);
        const startTime = performance.now();

        const countUp = (timestamp) => {
          const elapsed = performance.now() - startTime;
          const countValue = (from + (elapsed / duration) * increment).toFixed(
            deciamlPointLength
          );

          if (countValue >= to) {
            // countValue が カウント終了値以上になったら終了
            counterEle.innerText = to.toLocaleString();
          } else {
            // カウンターを更新して次のアニメーションを実行
            counterEle.innerText = parseFloat(countValue).toLocaleString();
            requestAnimationFrame(countUp);
          }
        };

        requestAnimationFrame(countUp);

        entry.target.classList.add("is-visible");
      }
    }
  });
};

const options = {
  threshold: 1,
};

const obsever = new IntersectionObserver(observeAction, options);

items.forEach((target) => {
  obsever.observe(target);
});

